import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Analytics = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M9.33 20v-6H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1zm0 0h5.33m-5.33 0V5a1 1 0 0 1 1-1h3.33a1 1 0 0 1 1 1v15m0 0V9h4.33a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='square'
        strokeLinejoin='round'
      />
    ) : (
      <>
        <g clip-path='url(#clip0_5946_16723)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M15.41 5v3.25h3.58c.966 0 1.75.784 1.75 1.75v9a1.75 1.75 0 0 1-1.75 1.75H5A1.75 1.75 0 0 1 3.25 19v-4c0-.966.784-1.75 1.75-1.75h3.58V5c0-.966.784-1.75 1.75-1.75h3.33c.966 0 1.75.784 1.75 1.75m-5.33 0a.25.25 0 0 1 .25-.25h3.33a.25.25 0 0 1 .25.25v14.25h-3.83zM5 14.75h3.58v4.5H5a.25.25 0 0 1-.25-.25v-4a.25.25 0 0 1 .25-.25'
            fill='currentColor'
          />
        </g>
        <defs>
          <clipPath id='clip0_5946_16723'>
            <rect width='24' height='24' fill='white' />
          </clipPath>
        </defs>
      </>
    )}
  </IconBase>
);
